import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import Meta from "vue-meta";
import { store } from "./store";
//import VueCompositionApi from "@vue/composition-api";
import Vue2TouchEvents from "vue2-touch-events";
// @ts-ignore

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
//Vue.use(VueCompositionApi);
Vue.use(Meta);
Vue.use(require("vue-moment"));
Vue.use(Vue2TouchEvents);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
